import React from "react";
import DigitalDetail from "./DigitalDetail";
import PhysicalDetail from "./PhysicalDetail";

const GiftCardDetail = ({
  currentStep,
  previewVisible,
  togglePreview,
  previewSettings,
  preview,
  giftCardData,
  moneyFormat,
  isMarketsCurrency,
  fulfillmentType,
  inDashboard = false,
}) => {

  if (fulfillmentType === "physical") {
    return (
      <PhysicalDetail
        currentStep={currentStep}
        previewVisible={previewVisible}
        togglePreview={togglePreview}
        previewSettings={previewSettings}
        preview={preview}
        giftCardData={giftCardData}
        inDashboard={inDashboard}
      />
    );
  }

  if (!fulfillmentType || fulfillmentType === "digital") {
    return (
      <DigitalDetail
        currentStep={currentStep}
        previewVisible={previewVisible}
        togglePreview={togglePreview}
        previewSettings={previewSettings}
        preview={preview}
        giftCardData={giftCardData}
        moneyFormat={(isMarketsCurrency) ? moneyFormat : null}
        isMarketsCurrency={isMarketsCurrency}
      />
    )
  }
  
  return <></>;
};

export default GiftCardDetail;
